import swal from 'sweetalert2'
import api from '../../models/cycle'
import CycleEditModal from '../../components/modal/cycle_edit_modal'
import CycleAddModal from '../../components/modal/cycle_add_modal'

export default {
  name: 'cycledetail',
  components: {
    CycleEditModal,
    CycleAddModal
  },
  data() {
    return {
      is_active: 99,
      per_page: 100,
      active_page: 1,
      isLoad: false,
      date_select: null,
      str_data: '',
      modal_type: null,
      spl_id: '',
      spl_code: '',
      spl_name: '',
      spl_plant_code: '',
      result_data: {
        pagination: [],
        count: 0
      },
      modal_data: {
        opc_id: '',
        cdmp_id: '',
        spl_id: '',
        dk_id: '',
        cdc_date: '',
        cdc_truck_no: '',
        cdc_cycle_x: '',
        cdc_cycle_y: '',
        cdc_cycle_z: '',
        cdc_delivery_x: '',
        cdc_delivery_y: '',
        cdc_delivery_z: ''
      }
    }
  },
  methods: {
    backTopage() {
      this.$router.push({
        name: 'cycle'
      })
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    search() {
      this.isLoad = true
      var obj = {
        spl_id: this.spl_id,
        active: this.is_active,
        date: this.date_select === null ? '' : this.dateMonth(this.date_select),
        page: this.active_page,
        limit: this.per_page
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      api.getCycleDetail(
        this.$store.state.URLHost,
        this.header,
        result => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Cycle', result.message)
          }
          this.isLoad = false
        },
        error => {
          this.alert_msg('error', 'Cycle', error.message)
          this.isLoad = false
        }
      )
    },
    getSupplier() {
      api.getSupplier(
        this.$store.state.URLHost,
        this.spl_id,
        this.header,
        result => {
          if (result.response === true) {
            this.spl_code = result.data.code
            this.spl_name = result.data.name
            this.spl_plant_code = result.data.plantcode
          } else {
            this.alert_msg('warning', 'Cycle', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'Cycle', error.message)
        }
      )
    },
    addCycle() {
      this.modal_type = 0
      this.modal_data = {
        opc_id: 1,
        cdmp_id: '',
        dk_id: '',
        spl_id: this.spl_id,
        spl_name: this.spl_name,
        spl_plant_code: this.spl_plant_code,
        cdc_date: null,
        cdc_truck_no: '',
        cdc_cycle_x: '',
        cdc_cycle_y: '',
        cdc_cycle_z: '',
        cdc_delivery_x: '',
        cdc_delivery_y: '',
        cdc_delivery_z: ''
      }
      this.ModalBoots('CycleModal').show()
    },
    editCycle(obj) {
      this.modal_type = 1
      this.modal_data = obj
      this.ModalBoots('CycleModal').show()
    },
    orderStatus(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm Order Status : ' + (obj.cdc_is_disable === 0 ? 'Disable' : 'Enable'),
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            let formData = {
              cdc_is_disable: obj.cdc_is_disable === 0 ? 1 : 0
            }
            api.orderStatus(
              this.$store.state.URLHost,
              obj.cdc_id,
              formData,
              this.header,
              result => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.search()
              },
              error => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.search()
              }
            )
          }
        })
    },
    activeCycle(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm Active : Cycle Date ' + this.dateFormatDMY(obj.cdc_date),
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            let formData = {
              spl_id: obj.spl_id,
              dk_id: obj.dk_id
            }
            api.activeCycle(
              this.$store.state.URLHost,
              obj.cdc_id,
              formData,
              this.header,
              result => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.search()
              },
              error => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.search()
              }
            )
          }
        })
    },
    deleteCycle(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm delete : Pattern ' + obj.cdp_name + ' Cycle date ' + this.dateFormatDMY(obj.cdc_date),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel'
        })
        .then(result => {
          if (result.value) {
            api.deleteCycle(
              this.$store.state.URLHost,
              obj.cdc_id,
              this.header,
              result => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.search()
              },
              error => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.search()
              }
            )
          }
        })
    }
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      this.spl_id = this.$route.query.id !== undefined ? this.$route.query.id : this.spl_id
      if (sessionStorage.token) {
        this.getSupplier()
        this.activePage(1)
      } else {
        setTimeout(() => {
          this.getSupplier()
          this.activePage(1)
        }, 1000)
      }
      var myModalEl = document.getElementById('CycleModal')
      myModalEl.addEventListener('hide.bs.modal', event => {
        this.modal_type = null
      })
      $(document).on('show.bs.modal', '.modal', function() {
        var zIndex = 1040 + 10 * $('.modal:visible').length
        $(this).css('z-index', zIndex)
        setTimeout(function() {
          $('.modal-backdrop')
            .not('.modal-stack')
            .css('z-index', zIndex - 1)
            .addClass('modal-stack')
        }, 0)
      })
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/cycledetail.js